//选择企业成员的组件
import React, {useState, useEffect, useRef, useImperativeHandle, forwardRef} from "react"
import {Input, Space, Checkbox, Pagination, Tag, Spin} from "antd"
import IconDeleteTag from "../../iconfont/deleteTag/deleteTag";
import CloudApi from "../../../cloud/cloud_api";
import Message from "../../../common/message";
import noAccount from "../../../../pages/cloud/image/groupChatSop/noAccount.png";
import {nanoid} from "nanoid";
import {LoadingOutlined, SearchOutlined} from "@ant-design/icons";

let timer = null;
const ImForward = forwardRef((props, ref) => {

    const {wxid, getStatus} = props

    const [data, setData] = useState([])//全部数据
    const [selectData, setSelectData] = useState([])//已经选择的数据
    const [name, setNickName] = useState('')//筛选的字段

    const [person, setPerson] = useState([])//个人聊天
    const [group, setGroup] = useState([])//群聊

    const [loading, setLoading] = useState(true)

    const inputRef = useRef(null)

    useEffect(() => {
        CloudApi.getImChatRecentList(wxid, (data) => {
            setLoading(false)
            data.forEach((item, index) => {
                item.checked = false
            })
            setData(data)
        }, (data) => {
        })

    }, [props.wxid])

    useEffect(() => {
        getStatus(selectData)
    }, [selectData.length])

    useEffect(() => {
        inputRef.current.focus()
    }, [])

    //单选
    function onChange(id, type) {
        let newData = [...data]//获取全部的数据
        let newPerson = [...person]//获取全部的数据
        let newGroup = [...group]//获取全部的数据
        let newSelectData = [...selectData]//获取选中的数据

        if (type === 'person') {
            newPerson.forEach((item, index) => {
                if (item.id == id) {
                    item.checked = !item.checked
                    if (item.checked) {
                        newSelectData.push(item)
                        setSelectData(newSelectData)//判断选中的添加到右侧
                    } else {
                        newSelectData = selectData.filter(item => item.id != id)
                        setSelectData(newSelectData)//已经勾选住的数据
                    }
                }
            })
            newData.forEach((item, index) => {
                if (item.id == id) {
                    item.checked = !item.checked
                }
            })
            setData(newData)
            setPerson(newPerson)
        } else if (type === 'group') {
            newGroup.forEach((item, index) => {
                if (item.id == id) {
                    item.checked = !item.checked
                    if (item.checked) {
                        newSelectData.push(item)
                        setSelectData(newSelectData)//判断选中的添加到右侧
                    } else {
                        newSelectData = selectData.filter(item => item.id != id)
                        setSelectData(newSelectData)//已经勾选住的数据
                    }
                }
            })
            newData.forEach((item, index) => {
                if (item.id == id) {
                    item.checked = !item.checked
                }
            })
            setGroup(newGroup)
            setData(newData)
        } else {
            newData.forEach((item, index) => {
                if (item.id == id) {
                    item.checked = !item.checked
                    if (item.checked) {
                        newSelectData.push(item)
                        setSelectData(newSelectData)//判断选中的添加到右侧
                    } else {
                        newSelectData = selectData.filter(item => item.id != id)
                        setSelectData(newSelectData)//已经勾选住的数据
                    }
                }
            })
            setData(newData)
        }

    }

    //点击右侧的删除按钮
    function deleteMember(id) {
        let newData = [...data]
        let newPerson = [...person]//获取全部的数据
        let newGroup = [...group]//获取全部的数据
        //最近data
        newData.forEach((item) => {
            if (item.id == id) {
                item.checked = false
            }
        })
        setData(newData)

        //右侧筛选data
        let newSelectData = selectData.filter(item => item.id != id)
        setSelectData(newSelectData)

        //查询到的data
        newPerson.forEach(item => {
            if (item.id == id) {
                item.checked = false
            }
        })
        newGroup.forEach(item => {
            if (item.id == id) {
                item.checked = false
            }
        })
    }

    //点击清空按钮
    function emptyData() {
        let newData = [...data]
        let newPerson = [...person]
        let newGroup = [...group]

        newData.forEach((item) => {
            item.checked = false
        })
        newPerson.forEach(item => {
            item.checked = false
        })
        newGroup.forEach(item => {
            item.checked = false
        })

        setData(newData)
        setPerson(newPerson)
        setGroup(newGroup)
        setSelectData([])
    }

    function exportData() {
        return JSON.parse(JSON.stringify(selectData))
    }

    //搜索事件 Change
    function inputChange(e) {
        clearTimeout(timer)
        setLoading(true)
        let value = e.target.value
        //value为空展示最近联系人列表
        if (value === '') {
            setNickName('')
            let arr = [...data]
            selectData.forEach(item => {
                arr.forEach(obj => {
                    if (item.id == obj.id) {
                        obj.checked = true
                    }
                })
            })
            setLoading(false)
            setData(arr)
        } else {
            //value不为空 请求搜索接口，展示搜索到的列表
            timer = setTimeout(() => {
                getSearchList(value)
            }, 500)
            setNickName(value)
        }
    }

    const getSearchList = keyword => {
        let queryParam = {
            keyword: keyword,
            accountId: wxid,
        }
        CloudApi.getImContactSearchList(queryParam, data => {
            setLoading(false)
            data.friendList.forEach(item => item.id = item.friendId)
            data.roomList.forEach(item => item.id = item.roomId)

            selectData.forEach(item => {
                data.friendList.forEach(obj => {
                    if (item.id == obj.id) {
                        obj.checked = true
                    }
                })

                data.roomList.forEach(obj => {
                    if (item.id == obj.id) {
                        obj.checked = true
                    }
                })
            })
            setPerson(data.friendList)
            setGroup(data.roomList)
        }, error => {
            setLoading(false)
            setPerson([])
            setGroup([])
        })
    }

    useImperativeHandle(ref, () => ({
        exportData: exportData,
    }));

    return (
        <div className={'member_companies_im'}>
            <div>
                {/*添加成员教程？<a>添加成员教程</a>*/}
            </div>
            <div>
                <div className={'member_companies_left'}>
                    <div className={'member_companies_left_search'}>
                        <Space>
                            <Input
                                ref={inputRef}
                                prefix={<SearchOutlined style={{color: '#959595'}}/>}
                                placeholder="搜索"
                                style={{width: 291}}
                                value={name}
                                focus
                                onChange={inputChange}
                            />
                        </Space>
                    </div>
                    <Spin className={'im-forward-spin'} spinning={loading}>
                        <ul className={'im-forward-ul'}>
                            {
                                name == '' ?
                                    data.map((item, index) => {
                                        return <li key={item.id} style={{background: item.checked ? '#F7F7F7' : ''}}>
                                            <label>
                                                <Checkbox checked={item.checked} className={'im-forward-checkbox'}
                                                          onChange={onChange.bind(this, item.id)}/>
                                                <div>
                                                    <img src={item.avatar}/>
                                                    <div className={'im-forward-desc'}>
                                                        <span className={'im-forward-name-left'}>{item.name}</span>
                                                        {
                                                            //类型，1单聊、2群聊
                                                            item.type == 1 ?
                                                                //0企业好友，1微信好友
                                                                <span
                                                                    className={item.friendType == 1 ? 'forward_wx_name' : 'forward_qy_name'}>
                                                                {item.friendType == 1 ? '@微信' : item.corpName ? `@${item.corpName}` : ''}
                                                            </span>
                                                                : ''
                                                        }
                                                    </div>
                                                    {
                                                        item.type != 1 && item.roomType != 0 ?
                                                            <Tag className={'im-forword-tag'}>外部</Tag> : ''
                                                    }
                                                </div>
                                            </label>
                                        </li>
                                    })
                                    :
                                    <>
                                        {
                                            person.length ?
                                                <>
                                                    <div className={'im-forward-cate'} style={{marginTop: '0px'}}>联系人
                                                    </div>
                                                    {
                                                        person.map((item, index) => {
                                                            return <li key={item.id}
                                                                       style={{background: item.checked ? '#F7F7F7' : ''}}>
                                                                <label>
                                                                    <Checkbox checked={item.checked}
                                                                              className={'im-forward-checkbox'}
                                                                              onChange={onChange.bind(this, item.friendId, 'person')}/>
                                                                    <div>
                                                                        <img src={item.avatar}/>
                                                                        <div className={'im-forward-desc'}>
                                                                        <span
                                                                            className={'im-forward-name-left'}>{item.name}</span>
                                                                            {
                                                                                //0企业好友，1微信好友
                                                                                item.friendType == 1 ?
                                                                                    <span
                                                                                        className={item.friendType == 1 ? 'forward_wx_name' : 'forward_qy_name'}>
                                                                                    {item.friendType == 1 ? '@微信' : item.corpName ? `@${item.corpName}` : ''}
                                                                                </span> : ''
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            </li>
                                                        })
                                                    }
                                                </> : ''

                                        }

                                        {
                                            group.length ?
                                                <>
                                                    <div className={'im-forward-cate'}>群聊</div>
                                                    {
                                                        group.map((item, index) => {
                                                            return <li key={item.id}
                                                                       style={{background: item.checked ? '#F7F7F7' : ''}}>
                                                                <label>
                                                                    <Checkbox checked={item.checked}
                                                                              className={'im-forward-checkbox'}
                                                                              onChange={onChange.bind(this, item.roomId, 'group')}/>
                                                                    <div>
                                                                        <img src={item.avatar}/>
                                                                        <span
                                                                            className={'im-forward-name-left'}>{item.name}</span>
                                                                        {
                                                                            //0内部、1外部群
                                                                            item.roomType != 0 ?
                                                                                <Tag
                                                                                    className={'im-forword-tag'}>外部</Tag> : ''
                                                                        }
                                                                    </div>
                                                                </label>
                                                            </li>
                                                        })
                                                    }
                                                </> : ''
                                        }
                                    </>
                            }
                        </ul>
                    </Spin>
                    <div className={'paging_data_set'}>

                    </div>
                </div>
                <div className={'member_companies_right'}>
                    <div>
                        <div>
                            <span>已选择 {selectData.length} 个会话</span>
                        </div>
                        <span className={'empty_data'} onClick={emptyData}>清空</span>
                    </div>
                    <ul>
                        {
                            selectData.length ?
                                <>
                                    {
                                        selectData.map((item, index) => {
                                            return <li key={item.id}>
                                                <div>
                                                    <img src={item.avatar}/>
                                                    <div className={'im-forward-desc'}>
                                                        <span className={'im-forward-name-right'}>{item.name}</span>
                                                        {
                                                            //类型，1单聊、2群聊
                                                            item.type == 1 ?
                                                                //0企业好友，1微信好友
                                                                <span
                                                                    className={item.friendType == 1 ? 'forward_wx_name' : 'forward_qy_name'}>
                                                                {item.friendType == 1 ? '@微信' : item.corpName ? `@${item.corpName}` : ''}
                                                            </span>
                                                                : ''
                                                        }
                                                    </div>
                                                    {
                                                        item.type != 1 && item.roomType != 0 ?
                                                            <Tag className={'im-forword-tag'}>外部</Tag> : ''
                                                    }
                                                </div>
                                                <label
                                                    onClick={deleteMember.bind(this, item.id)}><IconDeleteTag/></label>
                                            </li>
                                        })
                                    }
                                </> :
                                <div className={'im-forward-empty'}>
                                    <img src={noAccount}/>
                                    <span>您还未选择聊天哦~</span>
                                </div>
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
})
export default ImForward